<template>
  <v-snackbar color="primary" shaped v-model="modelLogs" :vertical="false" @input="hide">
    <div v-for="(log, index) in logs" :key="index">
      <span v-if="log.description === 'created'" style="font-size: 15px"
        >Criou:</span
      >
      <span v-if="log.description === 'updated'" style="font-size: 15px"
        >Atualizou:
      </span>
      <span v-if="log.description === 'deleted'" style="font-size: 15px"
        >Deletou:
      </span>

      {{ log.nome_completo }}

      <br v-if="index !== logs.length - 1" />
    </div>

    <span v-if="logs.length == 0"
      >sem logs
      <br />
    </span>

    <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

    <template v-slot:action="{ attrs }">
      <v-btn color="error" icon v-bind="attrs" @click.native="hide">
        <v-icon large> mdi-close </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  name: "LogsAlvaras",

  props: {
    model: {
      required: null,
      type: Boolean,
    },
    logs: {
      required: null,
      type: Array,
    },
  },
  data() {
    return {
     modelLogs:this.model

    };
  },

  methods: {
  hide() {
    this.$emit('update:model', false);

    this.modelLogs = false
  }},
};
</script>
